import { Link as ChakraLink } from "@chakra-ui/react"
import React, { ComponentProps } from "react"
import { Link, useRouteMatch } from "react-router-dom"
import { ChakraProps } from "@chakra-ui/system"

type Props = {
  activeProps?: object
  exact?: boolean
  isDisabled?: boolean
}
& ComponentProps<Link>
& ChakraProps

const NavLink = ({
  to, activeProps, exact, children, isDisabled, ...rest
}: Props) => {
  const routeMatch = useRouteMatch({ path: to, exact })

  return (
    <ChakraLink
      as={Link}
      to={isDisabled ? undefined : to}
      pointerEvents={isDisabled ? "none" : "auto"}
      color={isDisabled ? "gray.400" : undefined}
      _hover={{}}
      _focus={{}}
      {...rest}
      {...routeMatch ? activeProps : {}}
      data-testid={routeMatch ? "active-nav-link" : undefined}
    >
      {children}
    </ChakraLink>
  )
}

export default NavLink
